module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fLJFT"))).then(() => module.bundle.root('hEqeo'));